import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
// import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { GetForm } from './modalForm';
export const MovePropertiesModal = observer(_ref => {
  let customTrigger = _ref.customTrigger,
    triggerRefresh = _ref.triggerRefresh;
  // const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '755-MovePropertiesModal'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('portfolios_properties_page.new_portfolio')));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('portfolios_properties_page.move_properties'),
    subTitle: t('portfolios_properties_page.you_are_about_to_move_num_properties', {
      propertiesNumber: store.portfoliosMultiActionStore.selectedItems.length
    }),
    variant: "staticHeight",
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger,
    noFooter: true,
    noPadding: true,
    noLeftButton: true
  }, /*#__PURE__*/React.createElement(GetForm, {
    triggerRefresh: triggerRefresh
  }));
});